import React from 'react';
import { BadgeCheckIcon, AwardIcon, ShieldIcon, BookOpenIcon, GraduationCapIcon, CarIcon, FileTextIcon } from 'lucide-react';
export function Qualifications() {
  const certificates = [{
    name: 'Diploma Beveiliger',
    icon: <ShieldIcon className="w-6 h-6 text-orange-500" data-id="element-351" />,
    primary: true
  }, {
    name: 'SVPB verklaring',
    icon: <FileTextIcon className="w-6 h-6 text-orange-500" data-id="element-352" />,
    primary: true
  }, {
    name: 'Certificaat Ploegleider BHV',
    icon: <ShieldIcon className="w-6 h-6 text-orange-500" data-id="element-353" />,
    primary: true
  }, {
    name: 'Retail & Management (niveau 4)',
    icon: <BookOpenIcon className="w-6 h-6 text-gray-400" data-id="element-354" />,
    primary: false
  }, {
    name: 'HAVO Natuur en Gezondheid',
    icon: <GraduationCapIcon className="w-6 h-6 text-gray-400" data-id="element-355" />,
    primary: false
  }, {
    name: 'Rijbewijs B',
    icon: <CarIcon className="w-6 h-6 text-gray-400" data-id="element-356" />,
    primary: false
  }];
  return <section className="py-16 border-b border-gray-800" data-id="element-357">
      <div className="max-w-6xl mx-auto" data-id="element-358">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 flex items-center gap-3" data-id="element-359">
          <ShieldIcon className="w-7 h-7 md:w-8 md:h-8 text-orange-500" data-id="element-360" />
          Beveiligingskwalificaties
        </h2>
        <p className="text-gray-400 mb-6 md:mb-8" data-id="element-361">
          Professionele certificeringen en kwalificaties voor
          beveiligingsdiensten
        </p>
        <div className="mb-8 md:mb-10" data-id="element-362">
          <h3 className="text-xl font-semibold mb-4 flex items-center gap-2" data-id="element-363">
            <BadgeCheckIcon className="w-6 h-6 text-orange-500" data-id="element-364" />
            Beveiligingscertificaten
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-365">
            {certificates.filter(cert => cert.primary).map((cert, index) => <div key={index} className="bg-gray-800 p-4 md:p-5 rounded-lg border-l-4 border-orange-500 shadow-md hover:shadow-lg transition-all flex items-center gap-4" data-id="element-366">
                  <div className="p-3 bg-gray-700 rounded-full" data-id="element-367">
                    <ShieldIcon className="w-6 h-6 text-orange-500" data-id="element-368" />
                  </div>
                  <div data-id="element-369">
                    <h3 className="font-medium" data-id="element-370">{cert.name}</h3>
                  </div>
                </div>)}
          </div>
        </div>
        <div data-id="element-371">
          <h3 className="text-xl font-semibold mb-4 flex items-center gap-2" data-id="element-372">
            <AwardIcon className="w-6 h-6 text-gray-500" data-id="element-373" />
            Aanvullende kwalificaties
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-374">
            {certificates.filter(cert => !cert.primary).map((cert, index) => <div key={index} className="bg-gray-800 p-4 md:p-5 rounded-lg border-l-2 border-gray-600 shadow-md flex items-center gap-4" data-id="element-375">
                  <div className="p-3 bg-gray-700 rounded-full" data-id="element-376">
                    {cert.icon}
                  </div>
                  <div data-id="element-377">
                    <h3 className="font-medium text-gray-300" data-id="element-378">{cert.name}</h3>
                  </div>
                </div>)}
          </div>
        </div>
        <div className="mt-8 md:mt-10 bg-gray-800 p-5 md:p-6 rounded-lg border-t border-orange-500 shadow-lg" data-id="element-379">
          <h3 className="text-xl font-semibold mb-3 flex items-center gap-2" data-id="element-380">
            <BadgeCheckIcon className="w-6 h-6 text-orange-500" data-id="element-381" />
            Professionele registratie
          </h3>
          <p className="text-gray-300 flex items-center gap-2" data-id="element-382">
            <span className="font-semibold" data-id="element-383">KVK nummer:</span> 73994979
          </p>
        </div>
      </div>
    </section>;
}